import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
   let reactPlugin = null;
   let appInsights = null;

   /**
    * Initialize the Application Insights class
    * @param {string} connectionString - Application Insights Connection String
    * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
    * @return {Object} - Initialized appInsights instance
    */
   const initialize = (connectionString, browserHistory) => {
      if (!connectionString) {
         console.error('[TelemetryService] Missing connection string');
         throw new Error('Application Insights connection string is missing.');
      }
      if (!browserHistory) {
         console.error('[TelemetryService] Missing browser history');
         throw new Error('Browser history is required for telemetry initialization.');
      }

      reactPlugin = new ReactPlugin();
      const LOG_LEVEL_DEFAULT = 0; // OFF

      appInsights = new ApplicationInsights({
         config: {
            connectionString: connectionString,
            maxBatchInterval: 0,
            disableFetchTracking: false,
            disableCorrelationHeaders: false,
            disableAjaxTracking: false,
            extensions: [reactPlugin],
            enableCorsCorrelation: true,
            correlationHeaderExcludedDomains: process.env.REACT_APP_INSIGHTS_EXCLUSION_DOMAINS
               ? process.env.REACT_APP_INSIGHTS_EXCLUSION_DOMAINS.split(',')
               : [],
            loggingLevelConsole: parseInt(process.env.REACT_APP_INSIGHTS_LOG_LEVEL_CONSOLE || LOG_LEVEL_DEFAULT),
            loggingLevelTelemetry: parseInt(process.env.REACT_APP_INSIGHTS_LOG_LEVEL_TELEMETRY || LOG_LEVEL_DEFAULT),
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            enableAutoRouteTracking: true,
            distributedTracingMode: 0,
            extensionConfig: {
               [reactPlugin.identifier]: {
                  history: browserHistory,
               },
            },
         },
      });

      appInsights.loadAppInsights();
      return appInsights;
   };

   return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
